export default "__VITE_ASSET__DMk4IuNu__"